import { useEffect, useState, useRef } from 'react';
import { withRouter } from 'react-router-dom';
import { Formik, Form } from 'formik';
import { useSelector, useDispatch } from 'react-redux';
import Coffee from './Coffee'
import { updateSubscription } from '../../reducers/subscription';
import { completeStep } from '../../reducers/steps';
import { calculateShipping } from '../../services/shipping';
import { trackPageView } from '../../services/tracking';
import { updateReducerAndForm } from '../../services/subscription';
import _ from 'lodash';

import { StyledCoffeesContainer, StyledWrapper } from './style';

import { Button } from '../button';
import { FormActions } from '../formActions';
import { PageHeader } from '../pageHeader';
import { PageBottom } from '../pageBottom';
import { PageBack } from '../pageBack';
import FormErrors from '../formErrors';
import SimpleBar from 'simplebar-react';

import Summary from '../summary';

function Customize({ history }){
  const formikRef = useRef();
  const dispatch = useDispatch();

  const [errors, setErrors] = useState([]);

  const subscription = useSelector((state) => state.subscription);
  const initialValues = { ...subscription };

  const steps = useSelector((state) => state.steps);

  let backUrl, backDescription;
  if(steps[2].complete){
    backUrl = '/perfil';
    backDescription = 'Dados pessoais';
  }
  else {
    backUrl = '/plano';
    backDescription = 'Sua caixinha';
  }

  const coffees = useSelector((state) => state.coffees);

  const validate = () => {
    setErrors([]);
    const values = formikRef.current.values;

    if(values && _.keys(values.coffees).length){
      return true;
    }
    else {
      setErrors(['Escolha seus cafés para continuar']);
      return false;
    }
  }

  const updateCoffees = async (coffees, setFieldValue) => {
    let quantity = 0;
    _.map(coffees, q => quantity += q);

    await updateReducerAndForm({
      coffees: coffees,
      quantity: quantity,
    }, setFieldValue || formikRef.current.setFieldValue);

    calculateShipping(subscription.zipcode, quantity);
  }

  const handleSubmit = (values) => {
    if(validate()){
      updateCoffees(values.coffees, formikRef.current.setFieldValue);

      dispatch(completeStep(2));

      history.push('/entrega');
    }
  }

  useEffect(() => {
    dispatch(updateSubscription({ planPage: 'customize' }));

    updateReducerAndForm({
      orderType: 1,
    }, formikRef.current.setFieldValue);

    if(subscription.zipcode && subscription.quantity){
      calculateShipping(subscription.zipcode, subscription.quantity);
    }

    trackPageView();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <Formik
        innerRef={formikRef}
        initialValues={initialValues}
        onSubmit={handleSubmit}
      >
        {({ setFieldValue, values }) => (
          <Form>
            <PageHeader>
              <small>Sua caixinha</small>
              <h1>Escolha você mesmo os seus cafés</h1>
              <p>
                <strong>Atenção</strong> Os cafés escolhidos abaixo serão enviados
                em todos os seus pedidos. Mas não se preocupe, você pode mudá-los a
                qualquer momento dentro da sua área de assinante.
              </p>
            </PageHeader>

            <PageBack to="/plano" text="Voltar" />

            <FormErrors errors={errors} />

            <StyledWrapper>
              <SimpleBar forceVisible="y" autoHide={false}>
                <StyledCoffeesContainer>
                  {coffees.map((coffee, i) => {
                    return <Coffee
                      key={i}
                      formikRef={formikRef}
                      validate={validate}
                      updateCoffees={updateCoffees}
                      coffee={coffee}
                    />
                  })}
                </StyledCoffeesContainer>
              </SimpleBar>
            </StyledWrapper>

            <PageBottom>
              <h4>Com dúvida para escolher o café?</h4>

              <a href="https://coffeeandjoy.com.br/quiz" target="_blank" rel="noreferrer">
                Conheça a sugestão coffee&joy
              </a>
            </PageBottom>

            <Summary />

            <FormActions backUrl={backUrl} backDescription={backDescription}>
              <Button type="submit" icon="angle-right" align="right">
                Continuar
              </Button>
            </FormActions>
          </Form>
        )}
      </Formik>
    </div>
  )
}

export default withRouter(Customize);
